import React, { Component } from "react";

import {
  InputControl,
  validateRequired,
  validateMin,
  validateEmail,
  validatePassword
} from "wvus-forms";

import {createCiamUserBySupporterNumber} from "../lib/requests";

import {UNEXPECTED_ERROR, EXISTING_ACCOUNT_ERROR, EXISTING_EMAIL} from '../lib/messages';


class CreateCiamAccountBySupporterNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      submissionError: false,
      loading: false,
    };

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  handleFormSubmit(e) {
    e.preventDefault();
    this.setState({ loading: true });
    // fail safe to bail if they get around disabled button
    if (!this.props.formMethods.isFormValid()) return false;

    const supporter_number  = this.props.supporterNumber;
    const { supporterEmail }  = this.props;

    const email = (!supporterEmail) ? this.props.formMethods.getFieldState(
      "wv-create-account-form-user"
    ).value : "";

    const password = this.props.formMethods.getFieldState(
      "wv-create-account-form-pass"
    ).value;

    const wp_nonce = window.wvusApiSettings.nonce;

    createCiamUserBySupporterNumber(supporter_number, email, password, wp_nonce )
      .then(response => {
        if(!response.data) {
          throw new Error();
        }

        const responseData = response.data;
        if (!responseData.success) {
          if(typeof responseData.code !== "undefined" && responseData.code == 409) {
            const message = EXISTING_EMAIL(email) ;
            window.location.href = `/login?wv_email=${email}&wv_message=${message}&wv_source=createAccount`;
            return;
          }
          if(typeof responseData.code !== "undefined" && responseData.code == 412) {
            this.setState({
              errorMessage: EXISTING_ACCOUNT_ERROR,
              submissionError: true,
              loading: false,
            });
            return;
          }

          const message =
          responseData.statusCode && responseData.error && responseData.message
              ? `Code: ${responseData.statusCode}, Error: ${
                responseData.error
                }, Message: ${responseData.message}`
              : "An error occurred";
          throw new Error(message);
        }

        this.props.setForm("Confirmation", supporterEmail || email, supporter_number);
      })
      .catch(response => {
        this.setState({
          errorMessage: UNEXPECTED_ERROR,
          submissionError: true
        });
      });
  }

  render() {

    const { formMethods, supporterEmail } = this.props;
    const { loading, submissionError, errorMessage } = this.state;
    const submitDisabled = !formMethods.isFormValid() || loading;

    const loadingIcon = loading ? (
      <span>
      <i className="fa fa-spinner fa-pulse fa-fw" />
      <span className="sr-only">Loading...</span>
      </span>
    ) : (
      ""
    );

    return (

      <form
        id="wv-create-ciam-account-form"
        className="wv-create-ciam-account-form wvus-form"
      >
        {submissionError ? (
          <p className="wv-create-account-error-message error-message" role="alert" aria-live="assertive">
            {errorMessage}
          </p>
        ) : (
          supporterEmail ?
            (<p>We found the email <strong>{supporterEmail}</strong> linked to this account. Create a password to finish.</p>) :
            (<p>We found your account. Enter an email and password to finish.</p>)
        )}

        {!supporterEmail &&
          <InputControl
            fieldName="wv-create-account-form-user"
            fieldTitle="Email address for sign-in"
            fieldType="email"
            fieldClasses="wv-create-account-form-user"
            formMethods={formMethods}
            validators={[validateRequired, validateEmail]}
          />
        }

        <InputControl
          fieldName="wv-create-account-form-pass"
          fieldTitle="Create a password"
          fieldType="password"
          fieldClasses="wv-create-account-form-pass"
          formMethods={formMethods}
          validators={[validateRequired, validatePassword]}
        />
        <p className="create-account__password-hint">
          At least 8 characters with a number, an uppercase letter, and a lowercase letter.
        </p>

        <button
          type="submit"
          id="wv-create-account-form-submit"
          className="btn btn-medium btn-primary create-account__submit"
          disabled={submitDisabled}
          onClick={this.handleFormSubmit}
        >
          {loadingIcon} Create Account
        </button>

      </form>
    );
  }
}
export { CreateCiamAccountBySupporterNumber };
